import {
  CircularProgress,
  LinearProgress,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";

export default function LoadingTestsInMass({ processedHosts, internalData }) {
  const theme = useTheme();
  return (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 1.5,
        minHeight: 300,
      }}
    >
      <Stack
        sx={{
          backgroundColor: theme.palette.background.textField,
          borderRadius: "100%",
          height: 60,
          width: 60,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress size={36} />
      </Stack>
      <Typography variant="h5" sx={{ marginTop: 1 }}>
        Executando testes de conectividade
      </Typography>
      <Typography color="text.secondary" variant="subtitle2">
        {processedHosts} de {internalData.length} hosts processados
      </Typography>
      <LinearProgress
        variant="determinate"
        value={(processedHosts / internalData.length) * 100}
        sx={{
          height: 8,
          borderRadius: 4,
          backgroundColor: theme.palette.background.textField,
          "& .MuiLinearProgress-bar": {
            backgroundColor: theme.palette.primary.main,
            borderRadius: 4,
          },
          width: "100%",
          maxWidth: 400,
        }}
      />
    </Stack>
  );
}
